var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 0H32.4316C33.6719 0 34.8633 0.498047 35.7422 1.37695L42.373 8.00781C43.252 8.88672 43.75 10.0781 43.75 11.3184V32.8125C43.75 35.4004 41.6504 37.5 39.0625 37.5H20.3125C17.7246 37.5 15.625 35.4004 15.625 32.8125V4.6875C15.625 2.09961 17.7246 0 20.3125 0ZM4.6875 12.5H12.5V18.75H6.25V43.75H25V40.625H31.25V45.3125C31.25 47.9004 29.1504 50 26.5625 50H4.6875C2.09961 50 0 47.9004 0 45.3125V17.1875C0 14.5996 2.09961 12.5 4.6875 12.5Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.e7c504bd186e3dff51acc8a36aba077b.svg";
export { ForwardRef as ReactComponent };